<template>
  <div class="public-shell">
    <main class="public-main">
      <router-view />
    </main>
    <footer class="public-footer">
      Igreja El Shaday
    </footer>
  </div>
</template>

<script>
export default { name: 'PublicLayout' }
</script>

<style scoped>
.public-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);
}
.public-main { flex: 1; }
.public-footer {
  padding: var(--spacing-lg);
  text-align: center;
  color: var(--color-text-muted);
  font-size: var(--text-xs);
}
</style>
